(function () {
  'use strict';

  var COMPONENT_SELECTOR = 'predictive-search[data-sh-search]';
  var RECENT_KEY = 'sickhaus_recent_searches_v2';
  var MAX_RECENT = 5;
  var KNOWN_QUERY_CORRECTIONS = {
    'mushroom lalp': 'mushroom lamp',
    'disco difuser': 'disco diffuser',
    'defuser': 'diffuser',
    'baloon dog': 'balloon dog',
    'eunner rug': 'runner rug',
    'book ends': 'bookends',
    'icecream': 'ice cream',
    'glitter ball': 'disco ball',
    'air difuser': 'disco diffuser',
    'flipclock': 'flip clock',
    'hiraku': 'hikaru',
    'het naked': 'get naked',
    'lalp': 'lamp',
    'bookend': 'bookends',
    'perspex': 'acrylic',
    'bin': 'waste bin',
    'mystic gaze woven': 'Mystic Gaze Woven Throw Blanket'
  };
  var instanceCounter = 0;
  var MOBILE_SEARCH_QUERY = '(max-width: 900px)';

  function isMobileSearchLayout() {
    return Boolean(window.matchMedia && window.matchMedia(MOBILE_SEARCH_QUERY).matches);
  }

  function portalHeaderSearch() {
    if (!isMobileSearchLayout()) return null;
    var container = document.querySelector('.site-header__search-container');
    if (!container) return null;
    if (container.dataset.shSearchPortaled === 'true') return container;

    var marker = document.createComment('sickhaus-search-portal');
    if (container.parentNode) container.parentNode.insertBefore(marker, container);
    container._shSearchPortalMarker = marker;
    container.dataset.shSearchPortaled = 'true';
    document.body.appendChild(container);
    return container;
  }

  function restoreHeaderSearch(container) {
    if (!container || container.dataset.shSearchPortaled !== 'true') return;
    var marker = container._shSearchPortalMarker;
    if (marker && marker.parentNode) {
      marker.parentNode.insertBefore(container, marker);
      marker.parentNode.removeChild(marker);
    }
    delete container._shSearchPortalMarker;
    delete container.dataset.shSearchPortaled;
  }

  function track(eventName, payload) {
    var detail = payload || {};
    detail.event = eventName;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    if (typeof window.clarity === 'function') {
      try { window.clarity('event', eventName); } catch (error) { /* no-op */ }
    }
  }

  function safeJsonParse(value, fallback) {
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/colour/g, 'color')
      .replace(/homeware/g, 'home decor')
      .replace(/&/g, ' and ')
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function correctKnownQuery(value) {
    var clean = String(value || '').trim().replace(/\s+/g, ' ');
    var correction = KNOWN_QUERY_CORRECTIONS[normalizeText(clean)];
    return correction || clean;
  }

  function renderCorrectionNotice(component, originalQuery, correctedQuery) {
    var existing = component.querySelector('[data-sh-search-correction]');
    if (existing) existing.remove();
    if (!originalQuery || !correctedQuery || normalizeText(originalQuery) === normalizeText(correctedQuery)) return;
    var resultSet = component.querySelector('[data-sh-search-result-set]');
    if (!resultSet) return;
    var notice = document.createElement('div');
    notice.className = 'sh-search-correction';
    notice.dataset.shSearchCorrection = '';
    notice.innerHTML = '<span>Corrected common spelling</span><strong>Showing “' + escapeHtml(correctedQuery) + '”</strong>';
    var head = resultSet.querySelector('.sh-search-results__head');
    if (head && head.nextSibling) resultSet.insertBefore(notice, head.nextSibling);
    else resultSet.insertBefore(notice, resultSet.firstChild);
  }

  function getRecentSearches() {
    try {
      var stored = safeJsonParse(window.localStorage.getItem(RECENT_KEY), []);
      return Array.isArray(stored) ? stored.filter(Boolean).slice(0, MAX_RECENT) : [];
    } catch (error) {
      return [];
    }
  }

  function saveRecentSearch(term) {
    var clean = String(term || '').trim().replace(/\s+/g, ' ');
    if (clean.length < 2) return;
    var recent = getRecentSearches().filter(function (item) {
      return item.toLowerCase() !== clean.toLowerCase();
    });
    recent.unshift(clean);
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, MAX_RECENT))); } catch (error) { /* no-op */ }
  }

  function parseIntents(component) {
    var source = component.querySelector('[data-sh-search-intents]');
    var intents = source ? safeJsonParse(source.textContent, []) : [];
    if (!Array.isArray(intents)) return [];
    return intents.filter(function (intent) {
      return intent && intent.title && intent.url && Array.isArray(intent.aliases);
    }).map(function (intent) {
      intent._normalizedAliases = intent.aliases.map(normalizeText).filter(Boolean);
      intent._normalizedTitle = normalizeText(intent.title);
      return intent;
    });
  }

  function scoreIntent(query, intent) {
    var normalizedQuery = normalizeText(query);
    if (!normalizedQuery) return 0;
    var queryTokens = normalizedQuery.split(' ').filter(Boolean);
    var best = 0;

    intent._normalizedAliases.forEach(function (alias) {
      if (!alias) return;
      if (normalizedQuery === alias) {
        best = Math.max(best, 120 + alias.length);
        return;
      }
      if (normalizedQuery.indexOf(alias) !== -1 && alias.length >= 4) {
        best = Math.max(best, 92 + alias.split(' ').length * 4);
      }
      if (alias.indexOf(normalizedQuery) !== -1 && normalizedQuery.length >= 4) {
        best = Math.max(best, 76 + queryTokens.length * 3);
      }
      var aliasTokens = alias.split(' ').filter(Boolean);
      var overlap = queryTokens.filter(function (token) {
        return token.length > 2 && aliasTokens.indexOf(token) !== -1;
      }).length;
      if (overlap) {
        var coverage = overlap / Math.max(queryTokens.length, aliasTokens.length);
        best = Math.max(best, 30 + overlap * 13 + coverage * 20);
      }
    });

    if (normalizedQuery === intent._normalizedTitle) best = Math.max(best, 130);
    return best;
  }

  function getIntentMatches(component, query) {
    return (component._shIntents || []).map(function (intent) {
      return { intent: intent, score: scoreIntent(query, intent) };
    }).filter(function (match) {
      return match.score >= 58;
    }).sort(function (a, b) {
      return b.score - a.score;
    }).slice(0, 3);
  }

  function getDirectIntent(component, term) {
    var normalized = normalizeText(term);
    return (component._shIntents || []).find(function (intent) {
      return intent._normalizedTitle === normalized || intent._normalizedAliases.indexOf(normalized) !== -1;
    }) || null;
  }

  function renderIntentAssists(component, query) {
    var mounts = component.querySelectorAll('[data-sh-search-intent-mount]');
    if (!mounts.length) return;
    var matches = getIntentMatches(component, query);
    var resultSet = component.querySelector('[data-sh-search-result-set]');
    var noResults = resultSet && resultSet.classList.contains('sh-search-results--none');

    mounts.forEach(function (mount) {
      mount.innerHTML = '';
      if (!matches.length) return;
      var primary = matches[0].intent;
      var related = matches.slice(1);
      var html = '<section class="sh-search-intent' + (noResults ? ' sh-search-intent--recovery' : '') + '" aria-label="Recommended collection">' +
        '<div class="sh-search-intent__copy">' +
          '<span class="sh-search__label">' + (noResults ? 'Best place to continue' : 'Shop the collection') + '</span>' +
          '<strong>' + escapeHtml(primary.title) + '</strong>' +
          '<p>' + escapeHtml(primary.description || '') + '</p>' +
        '</div>' +
        '<div class="sh-search-intent__actions">' +
          '<a href="' + escapeHtml(primary.url) + '" data-sh-intent-link data-intent-title="' + escapeHtml(primary.title) + '" data-intent-rank="1">Explore collection <span aria-hidden="true">→</span></a>' +
          (related.length ? '<div class="sh-search-intent__related"><span>Also relevant</span>' + related.map(function (match, index) {
            return '<a href="' + escapeHtml(match.intent.url) + '" data-sh-intent-link data-intent-title="' + escapeHtml(match.intent.title) + '" data-intent-rank="' + (index + 2) + '">' + escapeHtml(match.intent.title) + '</a>';
          }).join('') + '</div>' : '') +
        '</div>' +
      '</section>';
      mount.innerHTML = html;
    });

    var viewKey = normalizeText(query) + '|' + matches[0].intent.url;
    if (component._shLastIntentView !== viewKey) {
      track('search_collection_assist_view', {
        search_term: query,
        collection_title: matches[0].intent.title,
        collection_url: matches[0].intent.url,
        search_context: component.dataset.context || 'header',
        no_results: Boolean(noResults)
      });
      component._shLastIntentView = viewKey;
    }
  }

  function resultOptions(component) {
    return Array.prototype.slice.call(component.querySelectorAll('[data-sh-predictive-results] [role="option"]'));
  }

  function resetActiveOption(component) {
    resultOptions(component).forEach(function (option) {
      option.classList.remove('is-sh-search-active');
      option.setAttribute('aria-selected', 'false');
    });
    component._shActiveIndex = -1;
    if (component.input) component.input.removeAttribute('aria-activedescendant');
  }

  function activateOption(component, nextIndex) {
    var options = resultOptions(component);
    if (!options.length) return;
    var index = (nextIndex + options.length) % options.length;
    options.forEach(function (option, optionIndex) {
      var active = optionIndex === index;
      option.classList.toggle('is-sh-search-active', active);
      option.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) {
        option.scrollIntoView({ block: 'nearest' });
        if (component.input) component.input.setAttribute('aria-activedescendant', option.id);
      }
    });
    component._shActiveIndex = index;
  }

  function announce(component, message) {
    var status = component.querySelector('[data-sh-search-status]');
    if (status) status.textContent = message || '';
  }

  function updateClearButton(component) {
    var clear = component.querySelector('[data-sh-search-clear]');
    if (clear) clear.hidden = !component.input || !component.input.value.trim();
  }

  function renderRecentSearches(component, scope) {
    if (component.dataset.shShowRecent !== 'true') return;
    var root = scope || component;
    var wrap = root.querySelector('[data-sh-recent-wrap]');
    var target = root.querySelector('[data-sh-recent-searches]');
    if (!wrap || !target) return;
    var recent = getRecentSearches();
    target.innerHTML = '';
    if (!recent.length) {
      wrap.hidden = true;
      return;
    }
    recent.forEach(function (term) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sh-search-recent__term';
      button.dataset.shRecentTerm = term;
      button.textContent = term;
      target.appendChild(button);
    });
    wrap.hidden = false;
  }

  function prepareResultOptions(component) {
    component._shResultRevision = (component._shResultRevision || 0) + 1;
    resultOptions(component).forEach(function (option, index) {
      option.id = 'ShSearchOption-' + component._shInstanceId + '-' + component._shResultRevision + '-' + (index + 1);
      option.setAttribute('aria-selected', 'false');
    });
    resetActiveOption(component);
  }

  function showStarter(component) {
    if (!component.predictiveSearchResults || !component._shStarterTemplate) return;
    var fragment = component._shStarterTemplate.content.cloneNode(true);
    component.predictiveSearchResults.innerHTML = '';
    component.predictiveSearchResults.appendChild(fragment);
    renderRecentSearches(component, component.predictiveSearchResults);
    component.predictiveSearchResults.classList.remove('is-loading');
    component.predictiveSearchResults.removeAttribute('aria-busy');
    component._shLastIntentView = '';
    resetActiveOption(component);
    component.open();
    announce(component, 'Trending searches, products and curated collections');
  }

  function chooseTerm(component, term) {
    var clean = String(term || '').trim();
    if (!clean || !component.input) return;
    component.input.value = clean;
    updateClearButton(component);
    component.input.focus();
    component.getSearchResults(clean);
  }

  function handleKeydown(component, event) {
    if (!component.input || event.target !== component.input) return;
    var options = resultOptions(component);
    if (event.key === 'ArrowDown' && options.length) {
      event.preventDefault();
      activateOption(component, component._shActiveIndex + 1);
    } else if (event.key === 'ArrowUp' && options.length) {
      event.preventDefault();
      activateOption(component, component._shActiveIndex <= 0 ? options.length - 1 : component._shActiveIndex - 1);
    } else if (event.key === 'Enter' && component._shActiveIndex >= 0 && options[component._shActiveIndex]) {
      var link = options[component._shActiveIndex].querySelector('a[href]');
      if (link) {
        event.preventDefault();
        link.click();
      }
    } else if (event.key === 'Escape') {
      event.preventDefault();
      component.close();
    }
  }

  function initComponent(component) {
    if (!component || component.dataset.shSearchReady === 'true') return;
    component.dataset.shSearchReady = 'true';
    instanceCounter += 1;
    component._shInstanceId = instanceCounter;
    component._shStarterTemplate = component.querySelector('[data-sh-search-starter-template]');
    component._shIntents = parseIntents(component);
    component._shActiveIndex = -1;
    component._shLastTrackedQuery = '';
    component._shLastIntentView = '';

    if (!component.input || !component.predictiveSearchResults) return;
    component.predictiveSearchResults.id = 'predictive-search-' + (component.dataset.context || 'header') + '-' + component._shInstanceId;
    component.input.setAttribute('aria-controls', component.predictiveSearchResults.id);

    component.input.addEventListener('focus', function () {
      component.classList.add('is-active');
      if ((component.dataset.context || 'header') === 'header') document.body.classList.add('predictive-overflow-hidden');
      track('search_open', { search_context: component.dataset.context || 'header' });
      if (!component.input.value.trim()) showStarter(component);
    });

    component.input.addEventListener('input', function () {
      updateClearButton(component);
      resetActiveOption(component);
      if (!component.input.value.trim()) showStarter(component);
    });

    component.input.addEventListener('keydown', function (event) {
      handleKeydown(component, event);
    });

    var clear = component.querySelector('[data-sh-search-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        component.input.value = '';
        updateClearButton(component);
        showStarter(component);
        component.input.focus();
      });
    }

    var form = component.querySelector('form[role="search"]');
    if (form) {
      form.addEventListener('submit', function () {
        var originalTerm = component.input.value.trim();
        var term = correctKnownQuery(originalTerm);
        if (term) {
          if (term !== originalTerm) component.input.value = term;
          saveRecentSearch(term);
          track('search_submit', {
            search_term: term,
            original_search_term: originalTerm,
            query_was_corrected: term !== originalTerm,
            search_context: component.dataset.context || 'header'
          });
        }
      });
    }

    component.addEventListener('click', function (event) {
      var popular = event.target.closest('[data-sh-search-term]');
      if (popular && component.contains(popular)) {
        event.preventDefault();
        var popularTerm = popular.textContent.trim().replace(/^↗\s*/, '');
        var forceQuery = popular.dataset.shSearchMode === 'query';
        var directIntent = forceQuery ? null : getDirectIntent(component, popularTerm);
        track(forceQuery ? 'search_trending_term_click' : 'search_popular_term_click', {
          search_term: popularTerm,
          search_context: component.dataset.context || 'header',
          direct_to_collection: Boolean(directIntent)
        });
        if (directIntent) {
          saveRecentSearch(popularTerm);
          window.location.href = directIntent.url;
        } else {
          chooseTerm(component, popularTerm);
        }
        return;
      }

      var recent = event.target.closest('[data-sh-recent-term]');
      if (recent && component.contains(recent)) {
        chooseTerm(component, recent.dataset.shRecentTerm || recent.textContent);
        track('search_recent_term_click', { search_term: recent.dataset.shRecentTerm || recent.textContent.trim(), search_context: component.dataset.context || 'header' });
        return;
      }

      var trendingProduct = event.target.closest('[data-sh-trending-product-link]');
      if (trendingProduct && component.contains(trendingProduct)) {
        track('search_trending_product_click', {
          product_title: trendingProduct.dataset.productTitle || trendingProduct.textContent.trim(),
          product_position: Number(trendingProduct.dataset.productPosition || 0),
          product_url: trendingProduct.getAttribute('href') || '',
          search_context: component.dataset.context || 'header'
        });
        return;
      }

      var collectionLink = event.target.closest('[data-sh-collection-link]');
      if (collectionLink && component.contains(collectionLink)) {
        track('search_starter_collection_click', {
          collection_title: collectionLink.dataset.collectionTitle || collectionLink.textContent.trim(),
          collection_url: collectionLink.getAttribute('href'),
          search_context: component.dataset.context || 'header'
        });
        return;
      }

      var intentLink = event.target.closest('[data-sh-intent-link]');
      if (intentLink && component.contains(intentLink)) {
        var intentTerm = component.input.value.trim();
        if (intentTerm) saveRecentSearch(intentTerm);
        track('search_collection_assist_click', {
          search_term: intentTerm,
          collection_title: intentLink.dataset.intentTitle || intentLink.textContent.trim(),
          collection_url: intentLink.getAttribute('href'),
          intent_rank: Number(intentLink.dataset.intentRank || 1),
          search_context: component.dataset.context || 'header'
        });
        return;
      }

      var resultLink = event.target.closest('[data-sh-search-result-link]');
      if (resultLink && component.contains(resultLink)) {
        var term = component.input.value.trim();
        if (term) saveRecentSearch(term);
        track('search_result_click', {
          search_term: term,
          result_type: resultLink.dataset.resultType || 'unknown',
          result_title: resultLink.textContent.trim().replace(/\s+/g, ' ').slice(0, 120),
          result_position: Number(resultLink.dataset.resultPosition || 0),
          result_url: resultLink.dataset.resultUrl || resultLink.getAttribute('href') || '',
          search_context: component.dataset.context || 'header'
        });
        return;
      }

      var viewAll = event.target.closest('[data-sh-view-all-results]');
      if (viewAll && component.contains(viewAll)) {
        var viewAllTerm = component.input.value.trim();
        if (viewAllTerm) saveRecentSearch(viewAllTerm);
        track('search_view_all', { search_term: viewAllTerm, search_context: component.dataset.context || 'header' });
      }
    });

    updateClearButton(component);
  }

  function patchPredictiveSearch() {
    var PredictiveSearch = window.customElements && window.customElements.get('predictive-search');
    if (!PredictiveSearch || PredictiveSearch.prototype._shSearchPatched) return false;

    var proto = PredictiveSearch.prototype;
    var originalOpen = proto.open;
    var originalClose = proto.close;

    proto._shSearchPatched = true;

    proto.open = function () {
      originalOpen.call(this);
      if (!this.matches(COMPONENT_SELECTOR)) return;
      this.classList.add('is-active');
      if ((this.dataset.context || 'header') === 'header') {
        portalHeaderSearch();
        document.body.classList.add('predictive-overflow-hidden');
        document.documentElement.classList.add('sh-search-open');
      }
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.style.display = 'block';
        this.predictiveSearchResults.setAttribute('aria-hidden', 'false');
      }
      if (this.input) this.input.setAttribute('aria-expanded', 'true');
    };

    proto.close = function () {
      if (this._shAbortController) this._shAbortController.abort();
      originalClose.call(this);
      if (!this.matches(COMPONENT_SELECTOR)) return;
      this.classList.remove('is-searching');
      this.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');
      document.documentElement.classList.remove('sh-search-open');
      if (this.predictiveSearchResults) this.predictiveSearchResults.setAttribute('aria-hidden', 'true');
      if (this.input) {
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }
      var clear = this.querySelector('[data-sh-search-clear]');
      if (clear) clear.hidden = !this.input || !this.input.value.trim();
      announce(this, '');
    };

    proto.getSearchResults = function (query) {
      if (!this.matches(COMPONENT_SELECTOR)) return;
      var component = this;
      var cleanQuery = String(query || '').trim();
      var requestQuery = correctKnownQuery(cleanQuery);
      if (!cleanQuery) {
        showStarter(component);
        return;
      }

      component._shSearchCache = component._shSearchCache || new Map();
      var cacheKey = normalizeText(requestQuery);
      var trackingKey = normalizeText(cleanQuery) + '|' + cacheKey;
      var cached = component._shSearchCache.get(cacheKey);
      if (cached) {
        component.predictiveSearchResults.innerHTML = cached;
        component.predictiveSearchResults.classList.remove('is-loading');
        component.predictiveSearchResults.removeAttribute('aria-busy');
        component.classList.remove('is-searching');
        prepareResultOptions(component);
        renderCorrectionNotice(component, cleanQuery, requestQuery);
        renderIntentAssists(component, requestQuery);
        component.open();
        announce(component, 'Search suggestions updated');
        return;
      }

      if (component._shAbortController) component._shAbortController.abort();
      component._shAbortController = 'AbortController' in window ? new AbortController() : null;
      component.classList.add('is-searching');
      component.predictiveSearchResults.classList.add('is-loading');
      component.predictiveSearchResults.setAttribute('aria-busy', 'true');
      announce(component, 'Searching');

      var limit = Number(component.dataset.shSearchLimit || 6);
      var params = new URLSearchParams({
        q: requestQuery,
        'resources[type]': 'product,query,collection,page,article',
        'resources[limit]': String(limit),
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor,tag,body',
        section_id: 'search-results'
      });
      var endpoint = (window.theme && theme.routes && theme.routes.predictiveSearch) || '/search/suggest';
      var requestOptions = component._shAbortController ? { signal: component._shAbortController.signal } : {};

      fetch(endpoint + '?' + params.toString(), requestOptions)
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search failed with status ' + response.status);
          return response.text();
        })
        .then(function (text) {
          var documentFragment = new DOMParser().parseFromString(text, 'text/html');
          var section = documentFragment.querySelector('#shopify-section-search-results');
          if (!section) throw new Error('Predictive search section was not returned');
          var html = section.innerHTML;
          component._shSearchCache.set(cacheKey, html);
          if (component._shSearchCache.size > 16) {
            component._shSearchCache.delete(component._shSearchCache.keys().next().value);
          }
          component.predictiveSearchResults.innerHTML = html;
          component.predictiveSearchResults.classList.remove('is-loading');
          component.predictiveSearchResults.removeAttribute('aria-busy');
          component.classList.remove('is-searching');
          prepareResultOptions(component);
          renderCorrectionNotice(component, cleanQuery, requestQuery);
          renderIntentAssists(component, requestQuery);
          component.open();

          var resultSet = component.querySelector('[data-sh-search-result-set]');
          var noResults = resultSet && resultSet.classList.contains('sh-search-results--none');
          announce(component, noResults ? 'No exact products. A relevant collection or suggested search may be available.' : 'Search suggestions updated');
          if (component._shLastTrackedQuery !== trackingKey) {
            track(noResults ? 'search_no_results' : 'search_query', {
              search_term: requestQuery,
              original_search_term: cleanQuery,
              query_was_corrected: requestQuery !== cleanQuery,
              search_context: component.dataset.context || 'header'
            });
            if (requestQuery !== cleanQuery) {
              track('search_query_corrected', {
                original_search_term: cleanQuery,
                corrected_search_term: requestQuery,
                search_context: component.dataset.context || 'header'
              });
            }
            component._shLastTrackedQuery = trackingKey;
          }
          if (window.AOS && typeof window.AOS.refreshHard === 'function') window.AOS.refreshHard();
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          component.classList.remove('is-searching');
          component.predictiveSearchResults.classList.remove('is-loading');
          component.predictiveSearchResults.removeAttribute('aria-busy');
          announce(component, 'Search is temporarily unavailable. Press Enter to view full results.');
          console.error(error);
        });
    };

    document.querySelectorAll(COMPONENT_SELECTOR).forEach(initComponent);
    return true;
  }

  function ensureOpenSearch(context) {
    var safeContext = context || 'header';
    var component = document.querySelector(COMPONENT_SELECTOR + '[data-context="' + safeContext + '"]');
    if (!component) return;
    initComponent(component);
    if (!component.input || !component.predictiveSearchResults) return;

    component.classList.add('is-active');
    component.predictiveSearchResults.style.display = 'block';
    component.predictiveSearchResults.setAttribute('aria-hidden', 'false');
    if (!component.input.value.trim()) showStarter(component);
  }

  function recoverAlreadyOpenSearch() {
    var container = document.querySelector('.site-header__search-container.is-active');
    var component = document.querySelector(COMPONENT_SELECTOR + '[data-context="header"].is-active');
    if (!container && !component) return;
    portalHeaderSearch();
    window.setTimeout(function () { ensureOpenSearch('header'); }, 0);
  }

  function boot() {
    if (patchPredictiveSearch()) {
      recoverAlreadyOpenSearch();
      return;
    }
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (patchPredictiveSearch()) {
        window.clearInterval(timer);
        recoverAlreadyOpenSearch();
      } else if (attempts > 40) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  document.addEventListener('predictive-search:open', function (event) {
    var context = event && event.detail && event.detail.context ? event.detail.context : 'header';
    if (context === 'header') {
      portalHeaderSearch();
      document.documentElement.classList.add('sh-search-open');
    }
    [0, 120, 320].forEach(function (delay) {
      window.setTimeout(function () { ensureOpenSearch(context); }, delay);
    });
  });

  document.addEventListener('predictive-search:close-all', function () {
    document.documentElement.classList.remove('sh-search-open');
    if (!isMobileSearchLayout()) {
      document.querySelectorAll('.site-header__search-container[data-sh-search-portaled="true"]').forEach(restoreHeaderSearch);
    }
  });

  if (window.matchMedia) {
    var mobileSearchMedia = window.matchMedia(MOBILE_SEARCH_QUERY);
    var handleSearchModeChange = function (event) {
      if (event.matches) return;
      document.querySelectorAll(COMPONENT_SELECTOR + '[data-context="header"]').forEach(function (component) {
        if (component.classList.contains('is-active') && typeof component.close === 'function') component.close();
      });
      document.querySelectorAll('.site-header__search-container[data-sh-search-portaled="true"]').forEach(restoreHeaderSearch);
    };
    if (typeof mobileSearchMedia.addEventListener === 'function') mobileSearchMedia.addEventListener('change', handleSearchModeChange);
    else if (typeof mobileSearchMedia.addListener === 'function') mobileSearchMedia.addListener(handleSearchModeChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('click', function (event) {
    var product = event.target.closest('[data-sh-page-trending-product]');
    if (!product) return;
    track('search_page_trending_product_click', {
      product_title: product.dataset.productTitle || product.textContent.trim(),
      product_position: Number(product.dataset.productPosition || 0),
      product_url: product.getAttribute('href') || '',
      search_context: 'search-page'
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll(COMPONENT_SELECTOR).forEach(initComponent);
  });
}());
